export default __webpack_public_path__ + "static/media/banner3.a7174df7.svg";